module.exports = __webpack_public_path__ + "media/images/img-hobby-3-616d8d4f.jpg";